import {APP_INITIALIZE} from "./actions";
import $bus from '../../../events/global.event.bus'
import * as AppEvents from '../../../events/app'
import AuthService from '../../../services/auth.service'
import RegionService from '../../../services/region.service'
import AreaService from '../../../services/area.service'
import Mapper from '../../../mappers'
import _ from 'underscore'
// import BalanceService from "@/services/balance.service";
import RegistryPermissionService from "@/services/registry.permission.service";

export default {
    state: {
        regions: [],
        areas: [],
        login: null,
        isInitialized: false,
        lastAction: null,
        certificate: null,
        // balance: null,
        hasAccessToImportFromRegistry: false
    },
    getters: {
        appRegions: (state) => {
            return state.regions
        },
        appAreas: (state) => {
            return state.areas
        },
        appIsInitialized: (state) => {
            return state.isInitialized
        },
        appLogin: (state) => {
            return state.login
        },
        inn: (state) => {
            if (state.login && state.login.organization && state.login.organization.inn) {
                return state.login.organization.inn;
            } else if (state.globalorganization && state.globalorganization.inn) {
                return state.globalorganization.inn;
            } else {
                return null;
            }
        },
        certificate: (state) => {
            return state.certificate
        },
        // balance: (state) =>{
        //     return state.balance
        // },
        hasAccessToImportFromRegistry: (state) =>{
            return state.hasAccessToImportFromRegistry
        },
    },
    mutations: {
        updateRegions(state, regions) {
            state.regions = regions
        },
        updateAreas(state, areas) {
            state.areas = areas
        },
        updateLogin(state, login) {
            state.login = login
        },
        updateIsInitialized(state, isInitialized) {
            state.isInitialized = isInitialized
        },
        setLastAction(state, lastAction) {
            state.lastAction = lastAction
        },
        setCertificate(state, certificate) {
            state.certificate = certificate
        },
        // setBalance(state, balance){
        //     state.balance = balance
        // },
        setAccessToImportFromRegistry(state, hasAccessToImportFromRegistry){
            state.hasAccessToImportFromRegistry = hasAccessToImportFromRegistry
        }
    },
    actions: {
        [APP_INITIALIZE]: ({commit, state}) => {
            if (!state.isInitialized) {
                // region initializer
                let regionsPromise = RegionService.getAll();
                regionsPromise.then(response => {
                    let regions = _.map(response.data, regionViewModel => {
                        return Mapper.mapRegion(regionViewModel)
                    })

                    commit('updateRegions', regions)
                })

                // area initializer
                let areasPromise = AreaService.getAll();
                areasPromise.then(response => {
                    let areas = _.map(response.data, areaViewModel => {
                        return Mapper.mapArea(areaViewModel)
                    })

                    commit('updateAreas', areas)
                })



                // login initializer
                let loginPromise = AuthService.getLogin()
                loginPromise.then(response => {
                    if(response.data.GlobalOrganization === undefined){
                        let login = Mapper.mapUser(response.data);
                        let permissionPromies = RegistryPermissionService.get(login.organization.id);
                        permissionPromies.then(response => {
                            let permission = response.data
                            commit('setAccessToImportFromRegistry', permission)
                        })
                        commit('updateLogin', login)
                    }
                    else {
                        let login = Mapper.mapGlobalUser(response.data);
                        commit('updateLogin', login)
                    }
                })

                Promise.all([regionsPromise, areasPromise, loginPromise])
                    .then(() => {
                        commit('updateIsInitialized', true)
                        $bus.$emit(AppEvents.APP_INITIALIZE_DONE)

                        commit('setLastAction', 'App login loaded')
                    })
                    .catch(() => {
                        $bus.$emit(AppEvents.APP_INITIALIZE_FAILED)
                    })
                    .finally(() =>{
                        // loginPromise.then(result => {
                            // let organizationId = 0 ;
                            // if (state.login && state.login.organization && state.login.organization.inn) {
                            //     organizationId = result.data.Organization.Id;
                            // } else if (state.globalorganization && state.globalorganization.inn) {
                            //     organizationId = state.globalorganization.inn;
                            // }
                            // if(organizationId !== 0){
                            //     let balancePromise = BalanceService.get({organizationId});
                            //     balancePromise.then(response => {
                            //         let balance = parseFloat(response.data);
                            //         commit('setBalance', balance);
                            //     });
                            // }
                        // });
                    })
            } else {
                $bus.$emit(AppEvents.APP_INITIALIZE_DONE)
            }
        }
    }
}
